import {Action} from '@ngrx/store';
import {IGlobalLoadingState} from '../state/global-loading.state';

export enum GLOBAL_LOADING_ACTION {
  INIT_GLOBAL_LOADING = 'INIT_GLOBAL_LOADING',
}

export class SetGlobalLoading implements Action {
  readonly type = GLOBAL_LOADING_ACTION.INIT_GLOBAL_LOADING;

  constructor(public payload: IGlobalLoadingState) {}
}
